import RoleForm from '../components/Form'
import useModalForm from '../../../@hooks/useModalForm'
import Service from '../../../@services/role'

export default function useModifierRoleDialog(cb) {
  const { open } = useModalForm(RoleForm)

  const openDialog = id => {
    return open(
      async req => {
        const res = await Service.update(req)
        if (typeof cb === 'function') {
          cb(res)
        }
      },
      async () => {
        const res = (await Service.getRoleDetail(id)) || {}
        return {
          id: res.id,
          name: res.name,
          permissions: res.permissions || [],
          description: res.description,
        }
      },
      {
        title: '添加角色',
      }
    )
  }

  return openDialog
}
